module.exports = __webpack_public_path__ + "img/digital-token.b8669b61.svg";